import styled from 'styled-components';

import { getColorPrimary } from '../../libs';

export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 7px 0;
  border: none;

  img {
    width: 24px;
    height: 24px;
    border-radius: 12px !important;
    z-index: 1;
    background: #f5f5f5;
  }

  &:after {
    content: '';
    position: absolute;
    height: 3px;
    width: 100%;
    top: 45%;
    background-image: linear-gradient(to right, ${getColorPrimary}15, ${getColorPrimary}, ${getColorPrimary}15);
  }
`;

export default Container;
